import React, { useState } from 'react';
import { useSwipeable } from 'react-swipeable';
import SwipeableViews from 'react-swipeable-views';
import { Tabs, Tab } from '@mui/material';
import MyTrippinGrid from './MyTrippinGrid';
import "../styles/trippinTabs.css"

function MyTrippinTabs() {
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const handleSwipeChange = (index) => {
    setTabIndex(index);
  };

  const handlers = useSwipeable({
    onSwipedLeft: () => setTabIndex((prev) => (prev < 1 ? prev + 1 : prev)),
    onSwipedRight: () => setTabIndex((prev) => (prev > 0 ? prev - 1 : prev)),
    trackMouse: true,
  });

  return (
    <div {...handlers} className="trippin-tabs-container">
      <Tabs
        value={tabIndex}
        onChange={handleTabChange}
        centered
        sx={{
          "& .MuiTabs-indicator": {
            backgroundColor: "#48c9b0",
          },
          "& .MuiTab-root": {
            fontFamily: "'Poppins', sans-serif",
            color: "#ffffff",
          },
          "& .MuiTab-root.Mui-selected": {
            color: "#48c9b0",
            fontWeight: "bold",
          },
        }}
      >
        <Tab label="My Trippins" />
        <Tab label="Tagged Trippins" />
      </Tabs>

      <SwipeableViews
        index={tabIndex}
        onChangeIndex={handleSwipeChange}
        enableMouseEvents
      >
        <div>
          <MyTrippinGrid fetchUrl="/mytrippins" isOwnerTab={true} />
        </div>
        <div>
          <MyTrippinGrid fetchUrl="/mytrippins/tagged/api" isOwnerTab={false} />
        </div>
      </SwipeableViews>
    </div>
  );
}

export default MyTrippinTabs;
